(function (angular) {
    'use strict';

    angular
        .module('app.sitemap')
        .config([
            '$stateProvider',
            sitemapRoutes,
        ]);
    
    function sitemapRoutes($stateProvider) {
        $stateProvider
            .state('app.sitemap', {
                url: '/sitemap',
                templateUrl: '/app/site/sitemap/sitemap.template.html',
                controller: 'app.sitemap.SitemapController'
            });
    }

})(angular);
